import SpecializationPage from "@/components/SpecializationPage";
import { IMG } from "@/lib/images";

export default function RestauroConservativo() {
  return (
    <SpecializationPage
      testid="restauro-conservativo-page"
      quoteService="Restauro conservativo"
      index="/ 12"
      title="Restauro Conservativo"
      lines={["Restauro", "conservativo."]}
      subtitle="Recuperiamo e valorizziamo le superfici tramite microaeroabrasione selettiva, pulitura e trattamento, nel pieno rispetto del materiale originale."
      image={IMG.stone}
      accent="Nuova vita alle superfici, con rispetto."
      intro={[
        "La microaeroabrasione selettiva è una tecnica di pulitura delicata e controllata che rimuove depositi, croste nere e vecchie finiture senza aggredire il supporto. Regolando pressione e micro-inerti, l'intervento è calibrato sulla fragilità di ogni superficie.",
        "Al termine della pulitura eseguiamo il consolidamento e il trattamento protettivo delle superfici, restituendo leggibilità, solidità e bellezza a facciate, pietre, intonaci ed elementi decorativi.",
      ]}
      specs={[
        { k: "Tecnica", v: "Microaeroabrasione" },
        { k: "Azione", v: "Selettiva e delicata" },
        { k: "Consolidamento", v: "Incluso" },
        { k: "Trattamento", v: "Protettivo" },
        { k: "Rispetto materiale", v: "Massimo" },
        { k: "Ambiti", v: "Anche edifici vincolati" },
      ]}
      benefits={[
        { t: "Pulitura selettiva", d: "Rimuove sporco e croste calibrando l'azione sul materiale, senza abrasioni dannose." },
        { t: "Rispetto dell'originale", d: "Preserva patine, dettagli e superfici storiche di valore." },
        { t: "Consolidamento", d: "Restituisce coesione e solidità a materiali degradati." },
        { t: "Trattamento protettivo", d: "Protegge le superfici da umidità, smog e agenti atmosferici." },
        { t: "Valorizzazione estetica", d: "Recupera colori, texture e leggibilità delle superfici." },
        { t: "Interventi mirati", d: "Adatto anche a contesti delicati ed edifici tutelati." },
      ]}
      applications={[
        "Facciate storiche",
        "Chiese ed edifici di culto",
        "Pietra naturale e marmi",
        "Intonaci e stucchi",
        "Elementi decorativi e modanature",
        "Cornici, capitelli e balaustre",
        "Colonne e lesene",
        "Monumenti e statue",
        "Edifici vincolati e tutelati",
        "Portali e bugnati",
        "Davanzali e soglie in pietra",
        "Superfici in laterizio faccia a vista",
        "Muri in tufo",
        "Fontane storiche",
        "Cortili, androni e loggiati",
        "Elementi in cemento decorativo",
      ]}
      faqs={[
        { q: "Cos'è la microaeroabrasione selettiva?", a: "È una tecnica di pulitura delicata e controllata che, regolando pressione e micro-inerti, rimuove depositi, croste nere e vecchie finiture senza aggredire il supporto sottostante." },
        { q: "Danneggia le superfici storiche o le patine originali?", a: "No. L'azione è calibrata sulla fragilità di ogni superficie proprio per preservare patine, dettagli e materiali originali di valore." },
        { q: "Si può intervenire su edifici vincolati o tutelati?", a: "Sì. La tecnica è adatta anche a contesti delicati ed edifici vincolati, nel pieno rispetto del materiale originale e delle prescrizioni di tutela." },
        { q: "Il restauro comprende anche la protezione finale?", a: "Sì. Dopo la pulitura eseguiamo il consolidamento dei materiali degradati e un trattamento protettivo che difende le superfici da umidità, smog e agenti atmosferici." },
      ]}
    />
  );
}
